import { render } from "./ServiceDetails.vue?vue&type=template&id=6ea03bc9"
import script from "./ServiceDetails.vue?vue&type=script&lang=js"
export * from "./ServiceDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__